import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Always send Bearer token if present.
//
// Security note: We deliberately use localStorage as a FALLBACK for the
// Bearer token in addition to the primary httpOnly + Secure + SameSite=None
// cookie (set by the backend at login). The cookie is the canonical auth
// store; the localStorage token only exists because some browsers/contexts
// (Emergent's preview iframe, third-party cookie blockers, ad-blocked
// fetches) silently drop the cookie on cross-origin requests, which would
// otherwise log the user out. The token here is the same JWT the cookie
// holds, so localStorage doesn't expand the attack surface — an XSS that
// could read it could equally hijack the page directly. Keeping this
// fallback is required for the app to function reliably in preview.
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("an_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    // Double-submit CSRF: echo the readable csrf cookie back in a header the
    // browser will never attach on a cross-site request.
    const csrf = document.cookie
        .split("; ")
        .find((c) => c.startsWith("csrf_token="))
        ?.split("=")[1];
    if (csrf) {
        config.headers = config.headers || {};
        config.headers["X-CSRF-Token"] = csrf;
    }
    return config;
});

export default api;

export function setStoredToken(token) {
    if (token) localStorage.setItem("an_token", token);
}

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
